import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '../components/layout/LegalLayout';
import './TermsPage.css';

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <LegalLayout
      title={t('legal.terms.title')}
      description={t('legal.terms.description')}
    >
      <div className="termsPage">
        <h1 className="termsPage__title">{t('legal.terms.title')}</h1>
        <p className="termsPage__lastUpdated">
          {t('legal.terms.lastUpdated')}: {t('legal.terms.effectiveDate')}
        </p>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.acceptance.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.acceptance.content')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.serviceDescription.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.serviceDescription.content')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.useRestrictions.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.useRestrictions.intro')}</p>
          <ul className="termsPage__list">
            <li>{t('legal.terms.useRestrictions.illegal')}</li>
            <li>{t('legal.terms.useRestrictions.harmful')}</li>
            <li>{t('legal.terms.useRestrictions.unauthorized')}</li>
            <li>{t('legal.terms.useRestrictions.interference')}</li>
            <li>{t('legal.terms.useRestrictions.reverse')}</li>
          </ul>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.userAccounts.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.userAccounts.intro')}</p>
          <p className="termsPage__text">{t('legal.terms.userAccounts.clerk')}</p>
          <p className="termsPage__text">{t('legal.terms.userAccounts.responsibility')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.subscription.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.subscription.intro')}</p>
          <p className="termsPage__text">{t('legal.terms.subscription.lemonSqueezy')}</p>
          <p className="termsPage__text">{t('legal.terms.subscription.renewal')}</p>
          <p className="termsPage__text">{t('legal.terms.subscription.cancellation')}</p>
          <p className="termsPage__text">{t('legal.terms.subscription.refunds')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.intellectualProperty.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.intellectualProperty.content')}</p>
          <p className="termsPage__text">{t('legal.terms.intellectualProperty.userContent')}</p>
          <p className="termsPage__text">{t('legal.terms.intellectualProperty.analysisOwnership')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.limitationOfLiability.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.limitationOfLiability.intro')}</p>
          <p className="termsPage__text">{t('legal.terms.limitationOfLiability.educational')}</p>
          <p className="termsPage__text">{t('legal.terms.limitationOfLiability.notMedical')}</p>
          <p className="termsPage__text">{t('legal.terms.limitationOfLiability.notLegal')}</p>
          <p className="termsPage__text">{t('legal.terms.limitationOfLiability.noWarranty')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.disclaimers.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.disclaimers.content')}</p>
          <p className="termsPage__text">{t('legal.terms.disclaimers.bias')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.termination.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.termination.content')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.governingLaw.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.governingLaw.content')}</p>
        </section>

        <section className="termsPage__section">
          <h2 className="termsPage__heading">{t('legal.terms.contact.title')}</h2>
          <p className="termsPage__text">{t('legal.terms.contact.content')}</p>
          <p className="termsPage__text">
            <a href="mailto:support@bodai.io" className="termsPage__link">support@bodai.io</a>
          </p>
        </section>
      </div>
    </LegalLayout>
  );
}

